import { Component, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import captureError from '@app/helpers/errors';
import { Box } from '@rebass/emotion';
import { rem } from '@app/styles/theme/layout';

import LoginLink from '../LoginLink';
import messages from './ErrorBoundary.messages';
import GenericError, {
  GenericErrorTitle,
  GenericErrorMessage,
} from '../GenericError/GenericError';

class ErrorBoundary extends Component<{}, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError = (): State => ({ hasError: true });

  componentDidCatch({ message, stack }: Error): void {
    captureError({
      stack,
      message,
      name: 'App Crashed',
      tags: [{ name: 'error_type', value: 'fatalError' }],
    });
  }

  render(): ReactNode {
    return this.state.hasError ? (
      <Box
        width="100%"
        maxWidth={rem(650)}
        my={[30, 40]}
        px={[20, 0]}
        mx="auto"
        data-testid="error-boundary-generic-error"
      >
        <GenericError>
          <GenericErrorTitle>
            <FormattedMessage {...messages.headline} />
          </GenericErrorTitle>
          <GenericErrorMessage>
            <FormattedMessage
              {...messages.login}
              values={{
                cta: (
                  <LoginLink>
                    <FormattedMessage {...messages.cta} />
                  </LoginLink>
                ),
              }}
            />
          </GenericErrorMessage>
        </GenericError>
      </Box>
    ) : (
      this.props.children
    );
  }
}

export default ErrorBoundary;

interface State {
  hasError: boolean;
}
